import { AddOptionInputProps } from './add-option-input.types'
import styles from './add-option-input.module.scss'
import cl from 'classnames'
import { Input } from '@touche-lts/panel-ui/dist'
import { KeyboardEventHandler, useState } from 'react'

const AddOptionInputComponent = (props: AddOptionInputProps) => {
  const { className, style, onInputValueAdded } = props

  const [value, setValue] = useState<string>('')

  const onKeyDown: KeyboardEventHandler<HTMLInputElement> = event => {
    if (!value) return
    const enterKeyCodes = ['Enter', 'NumpadEnter']
    const proceed = enterKeyCodes.includes(event.code)
    if (!proceed) return
    onInputValueAdded(value.trim())
    setValue('')
  }

  return (
    <div className={cl(styles.container, className)} style={style}>
      <Input
        colorPreset='dark'
        placeholder='Add more options'
        className={styles.input}
        value={value}
        onChange={setValue}
        onKeyDown={onKeyDown}
      />
    </div>
  )
}

const AddOptionInput = AddOptionInputComponent
export { AddOptionInput }
